const appSettings = {
  SME_SERVICE_BASE_URL: '/',
  AUTH_SERVICE_BASE_URL: '/',
  RBO_REDIRECT_URL: '//rbo.raiffeisen.ru',
  REDIRECT_URI: '//lk.sme.raiffeisen.ru',
  recaptchaPublicKey: '6LcipGkUAAAAAPhoOYhB55etiNgPkMGtsLFn6iNY'
};

export default appSettings;
